import React, { useState } from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function AzureClientSecretField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Client Secret cannot be blank');
    } else {
      setError(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <InputLabel htmlFor='password'>Client Secret</InputLabel>
        <OutlinedInput
          label='Client Secret'
          id='client-secret'
          type={showPassword ? 'text' : 'password'}
          aria-describedby='client-secret-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle secret visibility'
                onClick={handleClickShowPassword}
                edge='end'
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {error ? (
          <FormHelperText id='client-secret-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='client-secret-helper-text'>
            Enter the Azure Client Secret
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

